import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { DashboardAdHintOption, FlagObject } from './dashboard-ad-hint.model';
import { DashboardAdHintService } from './dashboard-ad-hint.service';

@Component({
  selector: 'app-dashboard-ad-hint',
  templateUrl: './dashboard-ad-hint.component.html',
  styleUrls: ['./dashboard-ad-hint.component.scss']
})
export class DashboardAdHintComponent implements OnInit {
  public option: DashboardAdHintOption | any;
  rootScopeData: RootScopeDeclare | any;

  @ViewChild('adhint', { static: false }) _htq: ElementRef;

  constructor(
    public service: DashboardAdHintService,
    private _facilityService: FacilityService,
    private rootScopeService: RootScopeService) {
  }

  ngOnInit(): void {
    this.getRootScopeData();
    this.service.firstOptionSource.subscribe(op => {
      this.option = op;
      if(this.option?.pointerPosition == 'bottom'){
        setTimeout(() => {
          if(!this._htq) return;
          const htRect = this._htq.nativeElement.getBoundingClientRect();
          this.option.top = this.option.top ? this.option.top - htRect.height - 20 : htRect.height - 20;
        }, 50);        
      }
    });
  }

  top(option: DashboardAdHintOption) {
    if (!option) return;
  }

  async onDismiss(flag:string, action: string) {
    if (action === 'gotIt' && flag) {
      const flagsToUpdate: FlagObject = {};
      flagsToUpdate[flag] = false;
      this._facilityService.updatedFacilityPreferenceForUser(flagsToUpdate);
      if (this.rootScopeData.popupData && this.rootScopeData.popupData.hasOwnProperty(flag)) {
        this.rootScopeData.popupData[flag]= false;
      }
    }
    this.option = null;
    this.service.onDismissed();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  updateRootScopeData(): void {
    this.rootScopeService.updateRootScope(this.rootScopeData);
  }
}
